import { render } from "./assessment-changes.vue?vue&type=template&id=48c68900&scoped=true&ts=true"
import script from "./assessment-changes.vue?vue&type=script&lang=ts"
export * from "./assessment-changes.vue?vue&type=script&lang=ts"

import "./assessment-changes.vue?vue&type=style&index=0&id=48c68900&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c68900"]])

export default __exports__